import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {TeamOverviewRowVm, TeamOverviewVm} from '../../models/team-dynamic.vm';

export interface TeamOverviewFilters {
  collectionUuid: string | null;
  sort: 'ASC' | 'DESC';
}

@Component({
  selector: 'app-team-overview',
  templateUrl: './team-overview.component.html',
  styleUrls: ['./team-overview.component.scss']
})
export class TeamOverviewComponent implements OnInit, OnChanges {
  private static readonly COLLAPSED_ROWS = 6;

  @Input() data: TeamOverviewVm | null = null;
  @Input() loading: boolean = false;

  @Output() filtersChanged = new EventEmitter<TeamOverviewFilters>();

  visibleRows: TeamOverviewRowVm[] = [];
  showAll: boolean = false;
  hasHiddenRows: boolean = false;
  categoryOptions: { label: string, value: string | null }[] = [];
  sortOptions: { label: string, value: 'ASC' | 'DESC' }[] = [];
  categoryValue: string | null = null;
  sortValue: 'ASC' | 'DESC' = 'DESC';

  constructor(private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.setSortOptions();
    this.setCategoryOptions();
    this.setVisibleRows();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.setCategoryOptions();
      this.setVisibleRows();
    }
  }

  onFilterChange() {
    this.filtersChanged.emit({collectionUuid: this.categoryValue, sort: this.sortValue});
  }

  toggleShowAll() {
    this.showAll = !this.showAll;
    this.setVisibleRows();
  }

  trackByUuid(index: number, row: TeamOverviewRowVm) {
    return row.teamUuid ?? index;
  }

  private setVisibleRows() {
    const rows = this.data?.rows ?? [];
    this.hasHiddenRows = rows.length > TeamOverviewComponent.COLLAPSED_ROWS;
    this.visibleRows = this.showAll ? rows : rows.slice(0, TeamOverviewComponent.COLLAPSED_ROWS);
  }

  private setCategoryOptions() {
    this.categoryOptions = [
      {label: this.translate.instant('td_team_overview_overall_column'), value: null},
      ...(this.data?.columns ?? []).map(column => ({label: column.title, value: column.uuid}))
    ];
  }

  private setSortOptions() {
    this.sortOptions = [
      {label: this.translate.instant('td_team_overview_lowest_score'), value: 'ASC'},
      {label: this.translate.instant('td_team_overview_highest_score'), value: 'DESC'}
    ];
  }
}
